<template>
  <div>
    <ValidationObserver v-slot="{}" ref="observer">
      <div class="md-layout">
        <div class="md-layout-item md-size-100" v-if="model.fullname.visible">
          <ValidationProvider
            name="Fullname"
            :rules="{ required: model.fullname.required }"
            v-slot="{ passed, failed }"
          >
            <md-field :class="[{ 'md-error': failed }, { 'md-valid': passed }]">
              <md-icon>assignment_ind</md-icon>
              <label>{{fullname}}</label>
              <md-input v-model="model.fullname.value" type="text"></md-input>
            </md-field>
          </ValidationProvider>
        </div>
        <div class="md-layout-item md-size-100" v-if="model.phone.visible">
          <ValidationProvider
            name="Phone"
            :rules="{ required: model.phone.required }"
            v-slot="{ passed, failed }"
          >
            <md-field :class="[{ 'md-error': failed }, { 'md-valid': passed }]">
              <md-icon>phone</md-icon>
              <label>{{phone}}</label>
              <md-input
                v-mask="'+994 (##) ###-##-##'"
                placeholder="+994 (__) ___-__-__"
                v-model="model.phone.value"
                type="tel"
                @click="onTelClick"
              ></md-input>
            </md-field>
          </ValidationProvider>
        </div>
        <div
          class="md-layout-item md-size-100"
          style="text-align: left"
          v-if="model.gender.visible"
        >
          <ValidationProvider
            name="gender"
            :rules="{ required: model.gender.required }"
            v-slot="{ failed, passed }"
          >
            <div class="md-layout">
              <div class="md-layout-item md-size-30">
                <md-radio v-model="gender" :value="true">
                  <i
                    style="font-size: 18pt"
                    :class="{ 'text-success': passed, 'text-danger': failed }"
                    class="fa fa-male"
                  ></i>
                </md-radio>
              </div>
              <div class="md-layout-item md-size-30">
                <md-radio v-model="gender" :value="false">
                  <i
                    style="font-size: 18pt"
                    :class="{ 'text-success': passed, 'text-danger': failed }"
                    class="fa fa-female"
                  ></i
                ></md-radio>
              </div>
            </div>
          </ValidationProvider>
        </div>
        <div class="md-layout-item md-size-100" v-if="model.age.visible">
          <ValidationProvider
            name="age"
            :rules="{ between: [0, 99], required: model.age.required }"
            v-slot="{ passed, failed }"
          >
            <md-field :class="[{ 'md-error': failed }, { 'md-valid': passed }]">
              <md-icon>update</md-icon>
              <label>{{age}}</label>
              <md-input
                v-model="model.age.value"
                type="number"
                min="0"
                max="99"
              ></md-input>
            </md-field>
          </ValidationProvider>
        </div>
        <div class="md-layout-item md-size-100" v-if="model.email.visible">
          <ValidationProvider
            name="email"
            :rules="{ email: true, required: model.email.required }"
            v-slot="{ passed, failed }"
          >
            <md-field :class="[{ 'md-error': failed }, { 'md-valid': passed }]">
              <md-icon>mail</md-icon>
              <label>Email</label>
              <md-input v-model="model.email.value" type="email"></md-input>
            </md-field>
          </ValidationProvider>
        </div>
        <div class="md-layout-item md-size-100" v-if="model.company.visible">
          <ValidationProvider
            name="company"
            :rules="{ required: model.company.required }"
            v-slot="{ passed, failed }"
          >
            <md-field :class="[{ 'md-error': failed }, { 'md-valid': passed }]">
              <md-icon>corporate_fare</md-icon>
              <label>{{company}}</label>
              <md-input v-model="model.company.value" type="text"></md-input>
            </md-field>
          </ValidationProvider>
        </div>
        <div class="md-layout-item md-size-100" v-if="model.position.visible">
          <ValidationProvider
            name="position"
            :rules="{ required: model.position.required }"
            v-slot="{ passed, failed }"
          >
            <md-field :class="[{ 'md-error': failed }, { 'md-valid': passed }]">
              <md-icon>rowing</md-icon>
              <label>{{position}}</label>
              <md-input v-model="model.position.value" type="text"></md-input>
            </md-field>
          </ValidationProvider>
        </div>
      </div>
    </ValidationObserver>
  </div>
</template>

<script>
import { mask } from "vue-the-mask";
import { askdetempty } from "../../services/helper";
import { ValidationObserver, ValidationProvider } from "vee-validate";
import { required, email, min, max, between } from "vee-validate/dist/rules";
import { extend } from "vee-validate";
extend("email", email);
extend("required", required);
extend("min", min);
extend("max", max);
extend("between", between);
export default {
  directives: { mask },
  props: {
    detail: Object,
  },
  components: {
    ValidationObserver,
    ValidationProvider,
  },
  computed: {
    fullname(){
      return this.$store.getters.langindex === 1
        ? "Full name"
        : "Tam adınız";
    },
    phone(){
      return this.$store.getters.langindex === 1
        ? "Phone"
        : "Telefon";
    },
    age(){
      return this.$store.getters.langindex === 1
        ? "Age"
        : "Yaş";
    },
    company(){
      return this.$store.getters.langindex === 1
        ? "Company"
        : "Şirkət";
    },
    position(){
      return this.$store.getters.langindex === 1
        ? "Position"
        : "Vəzifə";
    },
  },
  data() {
    return {
      gender: null,
      model: {
        fullname: { visible: false, value: "", required: false },
        phone: { visible: false, value: "", required: false },
        gender: { visible: false, value: "", required: false },
        age: { visible: false, value: null, required: false },
        email: { visible: false, value: "", required: false },
        company: { visible: false, value: "", required: false },
        position: { visible: false, value: "", required: false },
      },
    };
  },
  methods: {
    onTelClick() {
      if (!this.model.phone.value) this.model.phone.value = "+994 (";
    },
    validatePhoneNumber() {
      if (this.model.phone.visible) {
        if (this.model.phone.value === "+994 (") this.model.phone.value = "";

        if (this.model.phone.required)
          return this.model.phone.value.length === 19;
        else
          return (
            this.model.phone.value.length === 19 ||
            this.model.phone.value.length === 0
          );
      } else return true;
    },
    isvalid() {
      if (this.validatePhoneNumber()) return this.$refs.observer.validate();
      else
        return Promise.resolve(false);
    },
    showfield() {
      if (!this.detail) return;
      this.model.fullname.visible = this.detail.visible[0] === "1";
      this.model.phone.visible = this.detail.visible[1] === "1";
      this.model.gender.visible = this.detail.visible[2] === "1";
      this.model.age.visible = this.detail.visible[3] === "1";
      this.model.email.visible = this.detail.visible[4] === "1";
      this.model.company.visible = this.detail.visible[5] === "1";
      this.model.position.visible = this.detail.visible[6] === "1";

      this.model.fullname.required = this.detail.required[0] === "1";
      this.model.phone.required = this.detail.required[1] === "1";
      this.model.gender.required = this.detail.required[2] === "1";
      this.model.age.required = this.detail.required[3] === "1";
      this.model.email.required = this.detail.required[4] === "1";
      this.model.company.required = this.detail.required[5] === "1";
      this.model.position.required = this.detail.required[6] === "1";
    },
    value() {
      if (this.detail !== askdetempty) {
        if (this.model.gender.visible)
          this.model.gender.value = this.gender ? 1 : 0;
        return this.model;
      } else return null;
    },
  },
  mounted() {
    this.showfield();
  },
  watch: {
    detail() {
      this.showfield();
    },
  },
};
</script>

<style>
</style>